import InternalForm from './container';

export default InternalForm;
